<template>
  <div class="main">
    <div class="main-desc">
      <div>
        <el-image :src="require('../assets/image/wendesc.jpg')" class="main-img">
          <div slot="placeholder" class="custom-loading">
            <!-- 这里是你的自定义加载动画 -->
            <i class="el-icon-loading"></i>
          </div>
        </el-image>
      </div>
      <div class="wen-btnbox">
        <el-button class="btn" :type="activeId == 'dwnsl' ? 'primary' : ''" round size="small" @click="handleWLclick('dwnsl')">动物鸟兽类</el-button>
        <el-button class="btn" :type="activeId == 'zwhcl' ? 'primary' : ''" round size="small" @click="handleWLclick('zwhcl')">植物花草类</el-button>
        <el-button class="btn" :type="activeId == 'jxyyl' ? 'primary' : ''" round size="small" @click="handleWLclick('jxyyl')">吉祥寓意类</el-button>
        <el-button class="btn" :type="activeId == 'shqwl' ? 'primary' : ''" round size="small" @click="handleWLclick('shqwl')">生活器物类</el-button>
        <el-button class="btn" :type="activeId == 'jhgwl' ? 'primary' : ''" round size="small" @click="handleWLclick('jhgwl')">几何勾纹类</el-button>
        <el-button class="btn" :type="activeId == 'wzzsl' ? 'primary' : ''" round size="small" @click="handleWLclick('wzzsl')">文字装饰类</el-button>
        <el-button class="btn" :type="activeId == 'txdsl' ? 'primary' : ''" round size="small" @click="handleWLclick('txdsl')">天象地属类</el-button>
        <el-button class="btn" :type="activeId == 'xdtal' ? 'primary' : ''" round size="small" @click="handleWLclick('xdtal')">现代图案类</el-button>
        <span class="beian">网站备案号：渝ICP备2024032881号-1</span>
      </div>
    </div>
    <div class="main-con">
      <div class="w-list">
        <p class="w-title">
          {{ aWen.label }}
        </p>
        <div class="w-box">
          <vue-scroll style="width: 100%">
            <ul class="w-ul">
              <li
                :class="['w-li', aWId == item.id && !hoverWitem ? 'actived' : '']"
                :style="{ 'background-image': `url(${require(`../assets/image/wen/${activeId}/xuebitu.jpg`)})`, backgroundPosition: `-${item.x}px -${item.y}px` }"
                v-for="item in aWen.list"
                :key="item.list"
                @click="handleWItemClick(item.id)"
                @mouseenter="hoverWitem = true"
                @mouseleave="hoverWitem = false"
              ></li>
            </ul>
          </vue-scroll>
        </div>
      </div>
      <div class="w-con">
        <div class="w-imgbox">
          <i :class="['el-icon-arrow-left w-img-icon', aItemIndex == 0 ? 'disabled' : '']" @click="handleWImgClick(false)"></i>
          <div class="w-img">
            <el-image :src="require(`../assets/image/wen/${activeId}/${aItem.id}.jpg`)" fit="contain" style="width: 100%; height: 100%" :preview-src-list="srcList" @load="isLoadImg = true">
              <div slot="placeholder" class="custom-loading">
                <!-- 这里是你的自定义加载动画 -->
                <i class="el-icon-loading"></i>
              </div>
            </el-image>
            <div class="icon-viewlarger" v-show="isLoadImg">
              <svg t="1716481215823" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3523" width="24" height="24">
                <path
                  d="M469.333333 192c153.173333 0 277.333333 124.16 277.333334 277.333333 0 68.053333-24.533333 130.410667-65.216 178.688l164.885333 170.218667-48.341333 49.877333-167.594667-172.992A276.053333 276.053333 0 0 1 469.333333 746.666667c-153.173333 0-277.333333-124.16-277.333333-277.333334S316.16 192 469.333333 192z m0 64c-117.824 0-213.333333 95.509333-213.333333 213.333333s95.509333 213.333333 213.333333 213.333334 213.333333-95.509333 213.333334-213.333334-95.509333-213.333333-213.333334-213.333333z m32 85.333333v96H597.333333v64h-96V597.333333h-64v-96.021333L341.333333 501.333333v-64l96-0.021333V341.333333h64z"
                  p-id="3524"
                  fill="#ffffff"
                ></path>
              </svg>
            </div>
          </div>
          <i :class="['el-icon-arrow-right w-img-icon', aItemIndex == aWen.list.length - 1 ? 'disabled' : '']" @click="handleWImgClick(true)"></i>
        </div>
        <div class="w-item">
          <p class="w-title">
            {{ aItem.title }}
            <span class="w-sub-title">{{ aItem.pinyin }}</span>
          </p>
          <div class="w-desc">
            <vue-scroll style="height: 100%">
              <ul>
                <li>
                  <p>土家语：</p>
                  <p>{{ aItem.tlang }}</p>
                </li>
                <li>
                  <p>尺寸：</p>
                  <p>{{ aItem.size }}</p>
                </li>
                <li>
                  <p>织造者：</p>
                  <p>{{ aItem.author }}</p>
                </li>
                <li>
                  <p>纹样说明：</p>
                  <p style="line-break: anywhere">
                    {{ aItem.desc }}
                  </p>
                </li>
              </ul>
            </vue-scroll>
          </div>
          <!-- <a class="btn-a" :href="require(`../assets/image/wen/${activeId}/${aItem.id}.jpg`)" target="_black" :download="aItem.title">
            <el-button class="btn" round size="small">保存图片</el-button>
          </a> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { wenList } from '../assets/json/wen.json'
import {EventBus} from '../utils/eventBus.js'
export default {
  name: 'Wen',
  data() {
    return {
      changeItem: true,
      isLoadImg: false,
      hoverWitem: false,
      activeId: 'dwnsl',
      aWId: 'dsh1',
      wenList: wenList
    }
  },
  computed: {
    // 一个计算属性的 getter
    aWen() {
      // `this` 指向当前组件实例
      return this.wenList.find(item => item.id == this.activeId)
    },
    aItem() {
      return this.aWen.list.find(item => item.id == this.aWId)
    },
    aItemIndex() {
      return this.aWen.list.findIndex(item => item.id == this.aWId)
    },
    srcList() {
      return [require(`../assets/image/wen/${this.activeId}/${this.aWId}.jpg`)]
    }
  },
  mounted() {},
  methods: {
    onScroll() {},
    handleWLclick(id) {
      if(window.localStorage.getItem('isPlay') == "true"){
        EventBus.$emit('isPlay')
      }
      this.changeItem = false
      this.activeId = id
      this.aWId = this.aWen.list[0].id
      this.$nextTick(() => {
        this.changeItem = true
      })
    },
    handleWItemClick(id) {
      if(window.localStorage.getItem('isPlay') == "true"){
        EventBus.$emit('isPlay')
      }
      this.isLoadImg = false
      this.aWId = id
    },
    handleWImgClick(isLeft) {
      if(window.localStorage.getItem('isPlay') == "true"){
        EventBus.$emit('isPlay')
      }
      let i = this.aItemIndex
      if (isLeft) {
        i += 1
      } else {
        i -= 1
      }
      if (i < 0 || i == this.aWen.list.length) {
        return
      }
      this.aWId = this.aWen.list[i].id
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-scrollbar__wrap {
  overflow-x: hidden;
}
.main {
  max-height: 1000px;
  align-items: flex-end;
  .main-desc {
    width: 360px;
    height: 100%;
  }
}

.wen-btnbox {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .btn {
    width: calc(50% - 5px);
    margin-bottom: 12px;
  }
  .btn + .btn {
    margin-left: 0;
  }
}
.main-con {
  height: 82%;
  padding-left: 100px;
  padding-right: 80px;
  padding-bottom: 10px;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
}
.w-list {
  width: 100%;
  .w-title {
    font-family: SourceHanSansCNBold;
    font-size: 16px;
    color: #fff;
  }
  .w-box {
    width: 100%;
    height: 152px;
    margin-top: 16px;
    .w-ul {
      white-space: nowrap;
      height: 152px;
      padding: 10px 5px;
      cursor: pointer;
      .w-li {
        display: inline-block;
        flex-shrink: 0;
        width: 50px;
        height: 115px;
        margin: 0 2px;
        background-repeat: no-repeat;
        transition: all 0.3s;
        &:hover,
        &.actived {
          transform: scale(1.16);
          margin: 0 4px;
          & + .w-li {
            // margin-left: 0;
          }
        }
        &:first-child {
          margin-left: 0;
        }
      }
    }
  }
}
.w-con {
  display: flex;
  width: 100%;
  .w-imgbox {
    width: 40%;
    display: flex;
    align-items: center;
    justify-content: center;
    .w-img {
      width: 300px;
      height: 450px;
      margin: 0 30px;
      position: relative;
      .icon-viewlarger {
        width: 100%;
        height: 100%;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0;
        display: flex;
        background-color: rgba(0, 0, 0, 0.5);
        cursor: pointer;
        transition: all 0.3s;
        pointer-events: none;
        cursor: pointer;
      }
      &:hover .icon-viewlarger {
        opacity: 1;
      }
    }
    .w-img-icon {
      font-size: 24px;
      cursor: pointer;
      transition: all 0.3s;
      &.disabled {
        color: #868686;
        cursor: not-allowed;
      }
      &:not(.disabled):hover {
        color: #0070e5;
        font-weight: bold;
      }
    }
  }
  .w-item {
    padding-left: 5%;
    width: 60%;
    position: relative;
    .w-title {
      font-family: SourceHanSansCNBold;
      font-size: 30px;
      .w-sub-title {
        font-family: SourceHanSansCNBold;
        font-size: 16px;
        margin-left: 6px;
      }
    }
    .w-desc {
      height: calc(100% - 108px);
      li {
        margin-top: 26px;
        color: #868686;
        font-size: 12px;
        p:first-child {
          margin-bottom: 10px;
        }
        &:last-child {
          margin-top: 46px;
        }
      }
    }
    .btn-a {
      position: absolute;
      bottom: 0;
    }
  }
}
</style>
